export default __webpack_public_path__ + "static/media/5.0ce2ee25.png";